/**
 * Copyright 2021 The AMP HTML Authors. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS-IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {isFortesting} from './for-testing';

/**
 * Returns true if executing in a testing environment. Calls may be DCE'd when
 * compiled based on isFortesting.
 * @param {!Window=} opt_win
 * @return {boolean}
 */
export function isTest(opt_win) {
  if (!isFortesting()) {
    return false;
  }
  const win = opt_win || self;
  return !!(win.AMP_CONFIG?.test || win.__AMP_TEST || win['__karma__']);
}
